import { NgModule, ModuleWithProviders, inject } from "@angular/core";
import { Configuration } from "./configuration";
import { HttpClient } from "@angular/common/http";

@NgModule({
  imports: [],
  declarations: [],
  exports: [],
  providers: [],
})
export class ApiModule {
  public static forRoot(
    configurationFactory: () => Configuration,
  ): ModuleWithProviders<ApiModule> {
    return {
      ngModule: ApiModule,
      providers: [{ provide: Configuration, useFactory: configurationFactory }],
    };
  }

  constructor() {
    const parentModule = inject(ApiModule, { optional: true, skipSelf: true });
    const http = inject(HttpClient, { optional: true });

    if (parentModule) {
      throw new Error(
        "ApiModule is already loaded. Import in your base AppModule only.",
      );
    }
    if (!http) {
      throw new Error(
        "You need to import the HttpClientModule in your AppModule! \n" +
          "See also https://github.com/angular/angular/issues/20575",
      );
    }
  }
}
